export default {
  nav: {
    home: "መነሻ",
    lab: "የጥገና ክፍል",
    phones: "ስልኮች",
    showroom: "የእቃዎች ክፍል",
    visit: "ይጎብኙን እና ያግኙን",
    getEstimate: "የዋጋ ግምት",
    openMenu: "ምናሌ ክፈት",
    closeMenu: "ምናሌ ዝጋ",
    menu: "ምናሌ",
    sound: "ድምጽ",
    call: "ይደውሉ",
    tagline: "ሞባይል ምርኣይ · ካልጋሪ",
  },
  status: {
    openNow: "አሁን ክፍት ነው",
    closed: "ዝግ ነው",
    until: "እስከ",
    opensToday: "ዛሬ ይከፈታል በ",
    opensTomorrow: "ነገ ይከፈታል በ",
    opensSunday: "እሁድ ይከፈታል በ",
  },
  hero: {
    h1a: "የተበላሸ ቴክኖሎጂ፣",
    h1b: "በጥንቃቄ",
    h1c: "ወደ ህይወት እንመልሳለን።",
    sub: "Next-G Phone Repair ስልኮችን፣ ላፕቶፖችን እና የዕለት ተዕለት ቴክኖሎጂን በካልጋሪ በእውነተኛ የስራ ቤት ይጠግናል — ቀጥተኛ መልሶች፣ ጥንቃቄ ያለው ስራ፣ እና ያለ እርስዎ ፈቃድ ምንም አይጀመርም።",
    ctaQuote: "የጥገና ግምት ያግኙ",
    ctaVisit: "ሱቁን ይጎብኙ",
    est: "ካልጋሪ፣ AB",
    badge: "ግዢ እና ጥገና",
  },
  marquee: [
    "የማያ ጥገና", "የባትሪ ምትክ", "የባትሪ መሙያ መካፈያ", "የውሃ ጉዳት",
    "የካሜራ ክፍሎች", "የውሂብ ምልሻ", "የላፕቶፕ እንክብካቤ", "የሶፍትዌር እርዳታ",
  ],
  process: {
    chapter: "01",
    eyebrow: "የእኛ የስራ መንገድ",
    title: "አራት ደረጃዎች። ያለምስጢር፣ ያለግፊት።",
    lede: "በNext-G እያንዳንዱ ጥገና ተመሳሳይ ታማኝ ህዝብን ይከተላል — ስለመሳሪያዎ ምን እየተሰራ እንደሆነ እና ምን ዋጋ እንዳለው ሁልጊዜ ያውቃሉ።",
    steps: [
      { num: "01", title: "ያምጡት", body: "መሳሪያውን እንዳለ ይውሰዱት — ያለቀጠሮ፣ ያለማሸጊያ፣ ያለቅጽ። ውሃ ከገባበት ያልነጠረ ይይዙት እና በቀጥታ ይምጡ።" },
      { num: "02", title: "እንመረምራለን", body: "እንከፍተዋለን፣ ሃርድዌሩን እንፈትሻለን እና በቀላል ቋንቋ ምን እንደተበላሸ እንነግርዎታለን — ምንም ያልተበላሸውንም። ያለ ቴክኒካዊ ቃላት፣ ያለግምት።" },
      { num: "03", title: "እርስዎ ያፀድቃሉ", body: "ስራ ከመጀመሩ በፊት ግልጽ ዋጋ በCAD ያገኛሉ። እርስዎ አዎ እስኪሉ ድረስ ምንም አይጀመርም — መጠገን ካልተገባም እንነግርዎታለን።" },
      { num: "04", title: "ወደ እጅዎ ይመለሳል", body: "እንጠግናለን፣ እያንዳንዱን ተግባር እንደገና እንፈትሻለን እና መሳሪያውን ሲሰራ እንሰጣለን — አሮጌው ክፍል ማየት ከፈለጉ ይገኛል።" },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "የምንጠግነው",
    title: "ስልኮች፣ ላፕቶፖች እና በየቀኑ የምትተማመንባቸው ሁሉ።",
    items: [
      { title: "ሞባይል ምርኣይ", body: "ማያዎች፣ ባትሪዎች፣ መካፈያዎች፣ ካሜራዎች እና የውሃ ጉዳት ለiPhone እና ለAndroid።" },
      { title: "የላፕቶፕ ጥገና", body: "MacBook እና Windows ላፕቶፖች — የሃርድዌር ጥገናዎች፣ ማሻሻያዎች እና ዝግተኛ ስርዓቶች ማዳን።" },
      { title: "የሶፍትዌር ድጋፍ", body: "የጅምር ችግሮች፣ ያልተሳኩ ዝመናዎች፣ ተቋረጦች እና የመለያ ችግሮች በዝግታ ይፈታሉ።" },
      { title: "የመሳሪያ ምርመራ", body: "ምን እንደሆነ አያውቁም? የስራ ቤት ምርመራ በትክክል ምን እየሆነ እንደሆነ ይነግርዎታል።" },
      { title: "የተጨማሪ እቃዎች ክፍል", body: "ክዳኖች፣ መከላከያዎች፣ ቻርጀሮች፣ ሶስት እና የፈጣሪ መሳሪያዎች — በሱቅ ውስጥ ይገጥማሉ።" },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "በአንድ ደቂቃ ግምት",
    titleA: "ችግሩን ይምረጡ።",
    titleEm: "ከዚያ ይደውሉ",
    titleB: "— ወዲያውኑ ዋጋ እንሰጣለን።",
    body: "መሳሪያዎን እና ችግሩን ይምረጡ — ከዚያ እነዚህን ዝርዝሮች ይዘው ሱቁን ይደውሉ እና ወዲያውኑ ቀጥተኛ እና ታማኝ ዋጋ ያግኙ።",
    steps: ["መሳሪያዎን ይምረጡ", "ችግሩን ይምረጡ", "ዝርዝሮቹን ይዘው ይደውሉ"],
    ctaStart: "ግምቱን ይጀምሩ",
    ctaCall: "ይደውሉ",
    pricesLabel: "ትክክለኛ የመነሻ ዋጋዎች",
    prices: ["ሁሉም ጥገና ከCA $79 ጀምሮ", "ስክሪኖች፣ ባትሪዎች፣ መዋያዎች፣ ካሜራዎች እና ሌሎችም", "ምርመራ ሁልጊዜ ነፃ"],
  },
  location: {
    chapter: "04",
    eyebrow: "ሱቁን ያግኙ",
    titleEm: "— TD Bank አጠገብ።",
    lede: "ያለቀጠሮ መምጣት ይፈቀዳል። መሳሪያውን እንዳለ ይምጡ፣ የቀረውን እኛ እንይዛለን።",
    openMaps: "በካርታ ክፈት",
    visitContact: "ጉብኝት እና ግንኙነት",
  },
  lab: {
    chapter: "የጥገና ክፍል",
    eyebrow: "አገልግሎቶች",
    titleA: "እያንዳንዱ ጥገና፣",
    titleEm: "በቀላል ቋንቋ ተነግሮ።",
    lede: "ማንኛውንም አገልግሎት ይንኩት ምን እንደሚሸፍን እና የትኞቹን ምልክቶች እንደሚፈታ ለማየት። ግምት መጠየቅ ሁልጊዜ ነጻ ነው — እና ስራ ሁልጊዜ በእርስዎ ፈቃድ ይጀመራል።",
    notice: "ሊያስተውሉት የሚችሉት",
    ask: "ግምት ይጠይቁ",
    pricingTitle: "ዋጋ እዚህ እንዴት እንደሚሰራ",
    pricingBody: "የመስመር ላይ ክልሎች በCAD ውስጥ ቀዳሚ የእቅድ አሃዞች ናቸው። የመጨረሻው ዋጋ መሳሪያውን ከፈተሽን፣ ትክክለኛውን ሞዴል ካወቅን እና የክፍሎችን ተገኝነት ከፈተሽን በኋላ ይረጋገጣል — እና ስራ እርስዎ ግምቱን ሲያፀድቁ ብቻ ይጀመራል።",
    ctaTitleA: "የትኛው እንደሚሆን እርግጠኛ አይደለሁም?",
    ctaTitleEm: "በቃ ይጠይቁ።",
    ctaBody: "መሳሪያው ምን እያደረገ እንደሆነ ይግለጹ — ትክክለኛውን ጥገና እናሳይዎታለን።",
    ctaQuote: "የጥገና ግምት ያግኙ",
    ctaCall: "ይደውሉ",
    services: {
      screen: {
        title: "የተሰበረ ማያ ጥገና",
        blurb: "የተሰነጠቀ መስታወት፣ የሞቱ ፒክስሎች፣ በማያ ላይ መስመሮች ወይም የንክኪ ክፍል ማዳመጥ ሲያቆም። በስልኮች፣ በታብሌቶች እና በላፕቶፖች ላይ ማያዎችን በጥራት ተመሳሳይ ክፍሎች እንተካለን።",
        symptoms: ["የተሰነጠቀ ወይም የተሰበረ መስታወት", "ንክኪ አይሰራም", "መስመሮች፣ ነጥቦች ወይም ጥቁር አካባቢዎች", "ማያው ጥቁር ነው ግን ስልኩ ይናወጣል"],
      },
      battery: {
        title: "የባትሪ ምትክ",
        blurb: "ስልክዎ በ30% ላይ ከሞተ፣ በብርድ ከጠፋ ወይም ሙሉ ቀኑ በቻርጀር ከሚኖር፣ አዲስ ባትሪ አብዛኛውን ጊዜ ይመልሰዋል። ጤና ከዚያ በፊት እና በኋላ ይፈተሻል።",
        symptoms: ["ባትሪው በሰዓታት ውስጥ ይከራለው", "የዘፈቀደ መጥፋት", "ባትሪ እንፋሎት ማያውን ያነሳል", "በሶኬት ሲሰራ ብቻ ይሰራል"],
      },
      charging: {
        title: "የቻርጅ መካፈያ እና የኃይል ችግሮች",
        blurb: "የሚንቀጠቀጡ ኬብሎች፣ ዝግተኛ ቻርጅ ወይም በአንድ አንግል ብቻ የሚሞላ ስልክ። የቻርጅ መካፈያዎችን እናጸዳለን፣ እንጠግናለን ወይም እንተካለን እና የኃይል ችግሮችን እስከ ቦርዱ እንከታተላለን።",
        symptoms: ["ኬብሉ ይንቀጠቀጣል ወይም ይወድቃል", "በአንድ አንግል ብቻ ይሞላል", "ፍጹም አይሞላም", "የሽቦ አልባ ቻርጅ ይሰራል መካፈያው ግን አይደለም"],
      },
      backglass: {
        title: "የኋላ መስታወት እና የካብሌት ጉዳት",
        blurb: "የተሰነጠቀ የኋላ መስታወት እና የተጎተተ ፍሬም ከመልክ በላይ ነው — ምድር እና እርጥበት ይገባበታል። የኋላ መስታወትን እንተካለን እና ካብሌቶችን እንመልሳለን መሳሪያው እንደገና እንዲዘጋ።",
        symptoms: ["የተሰነጠቀ ወይም የተሰበረ የኋላ መስታወት", "ስልኩን ሲይዙ ስለስት ጠራጊ ዳርዎች", "የተጎተተ ወይም የተጠፋ ፍሬም", "የካሜራ ቀለበት የተፈታ ወይም የሚንቀጠቀጥ"],
      },
      camera: {
        title: "የካሜራ ምትክ እና ጥገና",
        blurb: "ዝቅተኛ ፎቶዎች፣ የሚንቀጠቀጥ ሌንዝ፣ ትኩረት ማድረግ ችግር ወይም ጥቁር የሚከፈት የካሜራ መተግበሪያ። የሌንዝ መስታወትን እና የካሜራ ሞጁሎችን እንተካለን።",
        symptoms: ["ፎቶዎች ሁልጊዜ ዝቅተኛ ናቸው", "ካሜራው ይንቀጠቀጣል ወይም ያንጸባረቃል", "በካሜራ መተግበሪያ ውስጥ ጥቁር ማያ", "የተሰነጠቀ የሌንዝ መስታወት"],
      },
      water: {
        title: "የውሃ ጉዳት ግምገማ",
        blurb: "በመሳሪያ ውስጥ ውሃ ከኮሮዥን ጋር የፍጥነት ውድድር ነው። ያልነጠረ ይይዘው ይምጡ — እንከፍተዋለን፣ ኮሮዥኑን እናጸዳለን እና ምን ማዳን እንደሚቻል ከማንኛውም ዋጋ በፊት እንገምግማለን።",
        symptoms: ["በውሃ ውስጥ ወድቋል ወይም ተንስኮበት", "ከተረጠጠ በኋላ ማያው ይንገላታል", "ስልኩ ከፈሳሹ በኋላ ሞተ", "በካሜራ ወይም በማያ ስር እርጥበት ይታያል"],
      },
      software: {
        title: "ሶፍትዌር፣ ተቋረጦች እና የጅምር ችግሮች",
        blurb: "በሎጎ ላይ ተራግፏል፣ ያልተሳኩ ዝመናዎች፣ የማያቆም ተቋረጦች ወይም የተዘጉ መለያዎች። የሶፍትዌር ችግሮችን እንፈታለን፣ ስርዓቶችን እንመልሳለን እና ወደ መሳሪያዎ እንዲገቡ እንረዳዎታለን።",
        symptoms: ["በጅምር ሎጎ ላይ ተራግፏል", "ዝመናው አልተሳካም እና መሳሪያው አይጀምርም", "መተግበሪያዎች ሁልጊዜ ይቋረጣሉ", "ከመለያዎችዎ ወይም ከመሳሪያዎ ተዘግተዋል"],
      },
      data: {
        title: "የውሂብ ምልሻ እና የመሳሪያ መዳረሻ",
        blurb: "ፎቶዎች፣ እውቂያዎች እና ፋይሎች በሞተ ወይም በተበላሸ መሳሪያ ላይ ተዘግተዋል። ሃርድዌሩ ሲፈቅድ ከስልኮች እና ከላፕቶፖች ውሂብ እንመልሳለን — መሳሪያው ራሱ ቢነጥርም።",
        symptoms: ["መሳሪያው አይነጥርም ግን ውሂቡ አስፈላጊ ነው", "ፎቶዎች ወይም ፋይሎች በተበላሸ ስልክ ላይ ተዘግተዋል", "የተረሱ የይለፍ ቃል ሁኔታዎች", "የሚወድቅ የላፕቶፕ ድራይቭ"],
      },
      laptop: {
        title: "የላፕቶፕ ሃርድዌር እና ሶፍትዌር ድጋፍ",
        blurb: "ማያዎች፣ ቁልፍ ሰሌዳዎች፣ ባትሪዎች፣ የማከማቻ ማሻሻያዎች፣ ዝግተኛ ስርዓቶች እና የቫይረስ ጽዳት — MacBook እና Windows ላፕቶፖች እንደ ስልኮች ተመሳሳይ ጥንቃቄ ያገኛሉ።",
        symptoms: ["የተሰነጠቀ የላፕቶፕ ማያ", "የሞቱ ቁልፎች ወይም የተሳሳተ ፊደል", "ላፕቶፑ ድንገት በጣም ዝግተኛ", "አይሞላም ወይም ኃይሉን አይይዝም"],
      },
      diagnostics: {
        title: "ምርመራ እና የጥገና ምክክር",
        blurb: "ምን እንደሆነ እርግጠኛ አይደለሁም? ያምጡት። መሳሪያውን እንመረምራለን፣ በቀላል ቋንቋ ምን እየሆነ እንደሆነ እንነግርዎታለን እና ስራ ከመጀመሩ በፊት ጥገኑን እንገምታለን።",
        symptoms: ["የሆነ ነገር ስህተት አለ ግን ምን እንደሆነ ግልጽ አይደለም", "ስለ ሌላ ሱቅ ዋጋ ሁለተኛ አስተያየት", "አሮጌ መሳሪያ — መጠገን ይገባዋል?", "በአንድ ጊዜ ብዙ ችግሮች"],
      },
      cleaning: {
        title: "ጥልቅ የጽዳት አገልግሎት",
        blurb: "የኪስ ጭራቆች፣ አቧራ እና ብክለት ቀስ በቀስ ተናቋች፣ መካፈያዎች እና ቁልፎችን ይይዛሉ። መሳሪያውን ከፍተን ውስጥም ውጭም ሙሉ እናጸዳለን — ብዙ ጊዜ የተደበዘዘ ድምጽ እና የጠፈጠፉ ቁልፎችን ይፈታል።",
        symptoms: ["የተደበዘዘ ወይም ዝቅተኛ ተናቋች", "የቻርጅ መካፈያ ጭራቅ የሞላው", "የጠፈጠፉ ወይም የተላከፉ ቁልፎች", "በካሜራ መስታወት ስር አቧራ"],
      },
    },
  },
  fixboth: {
    eyebrow: "ስልኮች እና ላፕቶፖች",
    title: "የሰበረ ስልክ። የሰበረ ላፕቶፕ። አንድ ቦታ።",
    steps: [
      "iPhone 17 Pro Max — የሰበረ ማያ ገጽ እና የኋላ መነጽር",
      "የዊንዶውስ ላፕቶፖች — HP፣ Dell እና ሌሎች",
      "MacBook — ማያዎች፣ ባትሪዎች፣ ቁልፍ ሰሌዳዎች",
      "እንደ አዲስ ሲሰራ ይውሰዱት",
    ],
    cta: "የጥገና ግምት ይጠይቁ",
  },
  buy: {
    shopLink: "ስልኮችን ይመልከቱ",
    eyebrow: "አዲስ እና ጥንታዊ ስልኮች",
    titleA: "ግዢ እና",
    titleEm: "ጥገና",
    titleB: "— አንድ ሱቅ፣ ሁለቱም።",
    lede: "አዲስ እና ጥንታዊ ስልኮችን እንሸጣለን — Samsung፣ iPhone እና Google Pixel — ሁሉም የተፈተኑ፣ ንቁ እና ለአገልግሎት ዝግጁ። ጥንታዊ ማለት በበጎ ሁኔታ ብቻ።",
    perks: [
      { title: "ከ6–12 ወር ዋስትና", body: "እያንዳንዱ ስልክ ከ6 ወር እስከ አንድ ሙሉ አመት ዋስትና አለው።" },
      { title: "ነጻ መከላከያ + ክዳን", body: "ከፍተኛ ጥራት ያለው የተጠናከረ የማያ መከላከያ እና የስልክ ክዳን፣ ከሚገዙት እያንዳንዱ ስልክ ጋር ነጻ።" },
      { title: "የተከታታይ ቅናሾች", body: "እያንዳንዱ ግዢ ለወደፊት ቅናሾች ያክልዎታል — ብዙ ሲገዙ ብዙ ይቆጥባሉ።" },
      { title: "የተፈተነ እና ንቁ", body: "ሙሉ በሙሉ የተፈተነ፣ ንቁ እና ሱቅ ሲወጡ ለአገልግሎት ዝግጁ።" },
    ],
    bestPrice: "በካልጋሪ እና በኤድመንተን — በእውነት በአልበርታ ሁሉ ምርጥ የስልክ ዋጋዎች።",
    brandsTitle: "የምንሸጠው",
    seriesNote: "…እና ሌሎችም በሱቅ። ለዛሬው ክምችት ይደውሉ።",
    cta: "ለዛሬ ክምችት ይደውሉ",
    iphoneLine: "iPhone 5 እና ከዚያ በላይ",
    pixelLine: "Pixel 6 እና ከዚያ በላይ",
  },
  showroom: {
    chapter: "የእቃዎች ክፍል",
    eyebrow: "ተጨማሪ እቃዎች እና የዕለት ተዕለት ቴክኖሎጂ",
    titleA: "ትንሽ፣",
    titleEm: "በጥንቃቄ የተመረጠ",
    titleB: "መደብር — መጋዘን አይደለም።",
    lede: "ክዳኖች፣ መከላከያ፣ ኃይል እና ሶስት፣ ለዕለት ተዕለት ህይወት የተመረጡ። እዚህ ያለው ሁሉ በካውንተሩ ላይ በራስዎ መሳሪያ ላይ ሊገጥም ወይም ሊሞከር ይችላል።",
    groups: { all: "ሁሉም", phones: "ስልኮች", protection: "መከላከያ", power: "ኃይል", audio: "ሶስት", wearables: "ሰዓቶች", car: "መኪና", studio: "ስቱዲዮ" },
    availability: "ተገኝነት እና ዋጋ በሱቅ ውስጥ ይረጋገጣል",
    stripEyebrow: "በአካል ይይዙ",
    stripTitle: "መደብሩ ብዙ ጊዜ ይለዋወጣል — ማሰስ ነጻ ነው።",
    stripVisit: "ጉብኝትዎን ያቅዱ",
    stripQuote: "የጥገና ግምት ያግኙ",
    items: {
      phones: { title: "አዲስ እና ጥንታዊ ስልኮች", blurb: "Samsung፣ iPhone እና Google Pixel — የተፈተኑ፣ ንቁ እና ለአገልግሎት ዝግጁ፣ ከ6 ወር እስከ አንድ አመት ዋስትና ጋር።" },
      cases: { title: "የስልክ ክዳኖች", blurb: "ቀጭን፣ ጠንካራ እና ግልጽ ክዳኖች ለትክክለኛው ሞዴልዎ — በሱቅ ውስጥ በስልክዎ ላይ ይሞክሩ።" },
      protectors: { title: "የማያ መከላከያ እና የካሜራ ጥበቃ", blurb: "የግላዊነት እና የተጠናከረ መስታወት፣ እና የሌንዝ ጥበቃ — እየጠበቁ በካውንተሩ ላይ ይገጥማል።" },
      cables: { title: "ኬብሎች እና ፈጣን ቻርጀሮች", blurb: "የተፈታኝ USB-C እና Lightning ኬብሎች፣ እና ለiPhone፣ ለAndroid እና ለታብሌቶች ጥራት ያላቸው ፈጣን ቻርጀሮች።" },
      power: { title: "ፓወር ባንኮች እና ቻርጀሮች", blurb: "ፈጣን የግንባር ቻርጀሮች፣ የሽቦ አልባ ቻርጀሮች፣ ብዙ መካፈያ ህቦች እና ለጉዞ ፓወር ባንኮች።" },
      car: { title: "የመኪና መሳሪያዎች", blurb: "የስልክ ያዢዎች እና መያዣዎች፣ እና የኬብል እና የሽቦ አልባ የመኪና ቻርጀሮች ለእያንዳንዱ መሳሪያ።" },
      audio: { title: "AirPods እና ሄድፎኖች", blurb: "AirPods፣ የሽቦ አልባ የጆሮ ማዳመጫዎች እና ሄድፎኖች — የዕለት ተዕለት ማዳመጥ።" },
      speakers: { title: "የሽቦ አልባ ሚኒ ስፒከሮች", blurb: "ተንቀሳቃሽ፣ ለውጭ ዝግጁ ስፒከሮች — ትልቅ ድምጽ በትንሽ አካል።" },
      smartwatches: { title: "ተመጣጣኝ ስማርት ሰዓቶች", blurb: "የዕለት ተዕለት ሰዓቶች የልብ ምት ይለካሉ፣ እርምጃ ይቆጥራሉ እና ከስልክዎ ጋር ይገናኛሉ።" },
      memory: { title: "የማህደረ ትውስታ ካርዶች", blurb: "microSD ካርዶች በሁሉም መጠኖች፣ ለስልኮች፣ ለካሜራዎች እና ለታብሌቶች።" },
      keyboards: { title: "ቁልፍ ሰሌዳዎች", blurb: "የኬብል እና የሽቦ አልባ ቁልፍ ሰሌዳዎች ለስራ፣ ለትምህርት እና ለመዝናኛ።" },
      creatorkit: { title: "የይዘት ፍጥረት ኪቶች", blurb: "የቀለበት መብራቶች፣ ተንቀሳቃሽ እና ቆሚ ትራይፖዶች፣ እና ሌሎች ብዙ ለፈጣሪዎች።" },
      creator: { title: "የፈጣሪ እና የቤት ስራ መሳሪያዎች", blurb: "ትራይፖዶች፣ መያዣዎች፣ የቀለበት መብራቶች እና ለጥሪዎች፣ ለትምህርት እና ለይዘት ትናንሽ የዴስክ ማሻሻያዎች።" },
      addons: { title: "የዕለት ተዕለት የስልክ እና የላፕቶፕ ተጨማሪዎች", blurb: "መያዣዎች፣ ሸፋኖች፣ ህቦች እና ዋናውን መሳሪያዎን በህይወት ቀላል የሚያደርጉ ትናንሽ ነገሮች።" },
      preowned: { title: "መሳሪያዎች እና የምትክ ክፍሎች", blurb: "በካውንተሩ ላይ ስለ አሁኑ መሳሪያዎች እና የምትክ ክፍሎች ይጠይቁ።" },
    },
  },
  visit: {
    chapter: "ጉብኝት እና ግንኙነት",
    eyebrow: "ይምጡ",
    titleA: "በ17th Ave SE ላይ ያለው ሱቅ፣",
    titleEm: "በቀጥታ TD Bank አጠገብ።",
    lede: "በስራ ሰዓት ውስጥ ያለቀጠሮ መምጣት ይፈቀዳል። መሳሪያውን እንዳለ ይምጡ — ቀጠሮ አያስፈልግም።",
    addressLabel: "አድራሻ",
    hoursLabel: "የስራ ሰዓቶች",
    call: "ይደውሉ",
    text: "ለሱቁ ጽሑፍ ይላኩ",
    email: "በኢሜይል ያግኙን",
    openMaps: "በካርታ ክፈት",
    planEyebrow: "መጀመሪያ ማቀድ ይመርጣሉ?",
    planTitle: "ጉዞዎን ከመጀመርዎ በፊት ቀዳሚ ግምት ያግኙ።",
    planCta: "የጥገና ግምት ያግኙ",
    mapTitle: "ወደ Next-G Phone Repair ካርታ",
  },
  quote: {
    eyebrow: "የጥገና ግምት",
    titleA: "ግልጽ ቁጥር፣",
    titleEm: "በአንድ ደቂቃ ገደማ።",
    lede: "ሶስት ፈጣን ምርጫዎች ምን እንደሆነ ይነግሩናል። ከዚያ ይደውሉ — ወዲያውኑ ግልጽ ዋጋ እንሰጣለን፣ ስራ ከመጀመሩ በፊት እርስዎ ያፀድቃሉ።",
    step: "ደረጃ",
    of: "ከ",
    stepTitle1: "ምን እንጠግናለን?",
    stepTitle2: "የትኛው ትውልድ፣ በግምት?",
    stepTitle3: "ምን እያደረገ ነው?",
    back: "ተመለስ",
    preliminary: "ቀዳሚ ግምት",
    planning: "የእቅድ ክልል",
    factorsTitle: "የመጨረሻውን ዋጋ የሚወስኑት",
    factors: [
      "ትክክለኛው ሞዴል እና ለእሱ የሚገኝ የክፍል ጥራት",
      "ጉዳቱ በመሳሪያው ውስጥ ምን ያህል እንደተስፋፋ",
      "የክፍሎች ተገኝነት እና የአህ ወሳኝ ሳምንት የአቅራቢ ዋጋዎች",
      "በነጻ ምርመራ ወቅት የሚገኙ ተጨማሪ ችግሮች",
    ],
    disclaimer: "ይህ ቀዳሚ እና አግባብ ያልሆነ ክልል ነው። ክፍሎች፣ ትክክለኛው ሞዴል፣ ምርመራ እና ተገኝነት የመጨረሻውን ዋጋ ሊለውጡ ይችላሉ — ስራ ከመጀመሩ በፊት ሁልጊዜ ከእርስዎ ጋር ይረጋገጣል።",
    call: "ይደውሉ",
    text: "ይህን ግምት በጽሑፍ ይላኩ",
    email: "ለሱቁ ኢሜይል ይላኩ",
    startOver: "እንደገና ጀምር",
    visitShop: "ሱቁን ይጎብኙ",
    categories: {
      iphone: { label: "iPhone", blurb: "ከiPhone 8 እስከ አዳዲስ Pro ሞዴሎች ሁሉም ትውልዶች።" },
      android: { label: "Android ስልክ", blurb: "Samsung፣ Google Pixel እና ሌሎች Android መሳሪያዎች።" },
      tablet: { label: "ታብሌት", blurb: "iPad እና Android ታብሌቶች በሁሉም መጠኖች።" },
      laptop: { label: "ላፕቶፕ", blurb: "MacBook እና Windows ላፕቶፖች፣ ሃርድዌር እና ሶፍትዌር።" },
    },
    tiers: {
      iphone: {
        older: { label: "አሮጌ iPhone", hint: "iPhone 8፣ X እና SE-ትውልድ መሳሪያዎች" },
        recent: { label: "የቅርብ ጊዜ iPhone", hint: "iPhone 11 – 14 ዘመን" },
        newest: { label: "አዲስ / Pro iPhone", hint: "iPhone 15 – 17 እና Pro ሞዴሎች" },
      },
      android: {
        standard: { label: "መደበኛ Android", hint: "የመጀመሪያ እና መካከለኛ ደረጃ ስልኮች" },
        recent: { label: "የቅርብ ጊዜ Android", hint: "የቅርብ ጊዜ የዋና ፍሰት ሞዴሎች" },
        flagship: { label: "ፍራግሺፕ Android", hint: "Galaxy S / Ultra፣ Pixel Pro እና ማመሳሰያዎች" },
      },
      tablet: {
        standard: { label: "መደበኛ ታብሌት", hint: "የዕለት ተዕለት እና አሮጌ ታብሌቶች" },
        recent: { label: "የቅርብ ጊዜ ታብሌት", hint: "የቅርብ ጊዜ iPad እና Android ሞዴሎች" },
        pro: { label: "Pro ታብሌት", hint: "iPad Pro እና ትላልቅ ፕሪሚየም ታብሌቶች" },
      },
      laptop: {
        standard: { label: "መደበኛ ላፕቶፕ", hint: "የዕለት ተዕለት እና አሮጌ ላፕቶፖች" },
        recent: { label: "የቅርብ ጊዜ ላፕቶፕ", hint: "የቅርብ ጊዜ የዋና ፍሰት እና ultrabook ሞዴሎች" },
        pro: { label: "ጨዋታ / Pro ላፕቶፕ", hint: "የጨዋታ ማሽኖች፣ MacBook Pro እና የስራ ጣቢያዎች" },
      },
    },
    issues: {
      screen: { label: "የተሰበረ ማያ", hint: "ስንጠቆች፣ የሞቱ ፒክስሎች ወይም የንክኪ ችግሮች" },
      battery: { label: "የባትሪ ምትክ", hint: "ፈጣን መውጣት፣ መጥፋት፣ እንፋሎት ወይም ደካማ ጤና" },
      charging: { label: "የቻርጅ ችግር", hint: "የተፈታ መካፈያ፣ አለመሙላት ወይም ቋሚ ኃይል" },
      backglass: { label: "የተሰበረ የኋላ መስታወት", hint: "የተሰነጠቀ የኋላ መስታወት ወይም የካብሌት ጉዳት" },
      camera: { label: "የካሜራ ችግር", hint: "የሌንዝ ጉዳት፣ የትኩረት ችግሮች ወይም ውድቅ ሞጁል" },
      water: { label: "የውሃ ጉዳት", hint: "የእርጥበት ንክኪ፣ ኮሮዥን ወይም ኃይል የለም" },
      software: { label: "የሶፍትዌር ችግር", hint: "ተቋረጦች፣ ዝመናዎች፣ ጅምር ወይም የመለያ ችግሮች" },
      data: { label: "የውሂብ ምልሻ", hint: "ፎቶዎች፣ ፋይሎች ወይም የመሳሪያ መዳረሻ ችግሮች" },
    },
    smsBody: "ሰላም Next-G፣ ስለ ጥገና እደውላለሁ። መሳሪያ፦ {device}። ችግር፦ {issue}።",
    emailSubject: "የጥገና ጥያቄ — Next-G",
    resultTitle: "ተዘጋጅቷል — አሁን ብቻ ይደውሉ።",
    callNow: "አሁን ይደውሉ",
    callLead: "እያንዳንዱ ጥገና የተለየ ነው፣ ስለዚህ በመስመር ላይ ከመገመት ይልቅ በቀጥታ ዋጋ እንሰጣለን። እነዚህን ዝርዝሮች ይዘው ይደውሉ እና ወዲያውኑ ቀጥተኛ መልስ ያገኛሉ።",
    readyTitle: "ሲደውሉ እነዚህን ያዘጋጁ",
    ready: ["ትክክለኛው ሞዴልዎ፣ ካውቁት", "መሳሪያው ምን እያደረገ — ወይም ማድረግ እንደተው", "ችግሩ መቼ እንደጀመረ"],
    noPrice: "ያለ እርስዎ ፈቃድ ምንም አይጀመርም። በስልክ የሚነገርልዎት ዋጋ እርስዎ የሚሰማሙበት ነው።",
  },
  footer: {
    explore: "ያስሱ",
    talk: "ያግኙን",
    hours: "ሰዓቶች",
    quote: "ግምት ያግኙ",
    rights: "ካልጋሪ፣ አልበርታ",
    line: "ያለቀጠሮ መምጣት ይፈቀዳል · ግምቶች ስራ ከመጀመሩ በፊት ይረጋገጣሉ",
    motto: "ለአዲሱ ትውልድ የአዲስ ትውልድ አገልግሎት።",
  },
};
